import { SEARCH_PARAM_NAMES } from 'constants/enums';
import { useState } from 'react';
import {
  buildSignInLink,
  buildSignUpLink,
  CHECKING_VERIFY_IDENTITY,
  VERIFY_IDENTITY,
  IDV_QUERY_PARAMS,
  IDV_STATUS,
} from 'utilities/links';

export const removeIdvSearchParams = (urlSearchParams) => {
  Object.values(IDV_QUERY_PARAMS).forEach((param) => {
    urlSearchParams.delete(param);
  });
  return urlSearchParams;
};

export const paramsExceptIdv = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  return removeIdvSearchParams(urlSearchParams);
};

const idvReturnParams = (idv_query_param, isGoldenPath) => {
  const searchParams = paramsExceptIdv();
  searchParams.set(idv_query_param, '1');

  if (isGoldenPath) {
    searchParams.set(SEARCH_PARAM_NAMES.INITIAL_PROGRESS, 85);
  }
  return encodeURIComponent(`?${searchParams}`);
};

// TODO (dadamo): The way we append params to the returnLink returned from `buildSignUpLink` is a bit hacky
// and requires some cleanup. There is no guarantee that `return_to` will be the last query param in the URL.
export const idvLink = `${buildSignUpLink({
  returnTo: true,
  step: VERIFY_IDENTITY,
})}${idvReturnParams(IDV_QUERY_PARAMS.REDIRECT)}`;

export const checkingIdvLink = `${buildSignUpLink({
  returnTo: true,
  step: CHECKING_VERIFY_IDENTITY,
})}${idvReturnParams(IDV_QUERY_PARAMS.REDIRECT)}`;

export const goldenPathIdvLink = `${buildSignUpLink({
  returnTo: true,
  step: VERIFY_IDENTITY,
  isGoldenPath: true,
})}${idvReturnParams(IDV_QUERY_PARAMS.REDIRECT, true)}`;

export const idvLoginLink = `${buildSignInLink({
  returnTo: true,
})}${idvReturnParams(IDV_QUERY_PARAMS.LOGIN)}`;

const useIdv = () => {
  const [idvNeeded, setIdvNeeded] = useState(false);
  const [idvFailed, setIdvFailed] = useState(false);
  const [showVerificationSuccessBanner, setShowVerificationSuccessBanner] =
    useState(false);

  const fetchIdvStatus = (orderData) => {
    const {
      idv: {
        status: idvStatus,
        required: idvRequired,
        block_suspended: blockSuspended,
      },
    } = orderData;

    const isIdvNeeded =
      idvRequired && (!idvStatus || idvStatus === IDV_STATUS.UNVERIFIED);

    const isIdvFailed =
      (blockSuspended || idvRequired) && idvStatus === IDV_STATUS.SUSPENDED;

    return { isIdvNeeded, isIdvFailed };
  };

  const updateIdvStatus = (orderData) => {
    const { isIdvNeeded, isIdvFailed } = fetchIdvStatus(orderData);
    setIdvNeeded(isIdvNeeded);
    setIdvFailed(isIdvFailed);
  };

  const updateShowVerificationSuccessBanner = (orderData) => {
    const {
      checking: {
        idv_required: checkingIdvRequired,
        idv_verified: checkingIdvVerified,
      },
    } = orderData;

    const showBanner = checkingIdvRequired && checkingIdvVerified;
    setShowVerificationSuccessBanner(showBanner);

    return showBanner;
  };

  return {
    idvNeeded,
    idvFailed,
    showVerificationSuccessBanner,
    fetchIdvStatus,
    updateIdvStatus,
    updateShowVerificationSuccessBanner,
  };
};

export default useIdv;
